var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo",style:({zIndex:_vm.active? -1:''})},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.app.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }